import { createContext, useContext, useEffect } from 'react';
import axios from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { givingApi, type GivingAccess } from '@/api/giving';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { clearFinancialState } from './accessState';

export const TreasureContext = createContext<{ access: GivingAccess; churchId: string; userId: string } | null>(null);
export function useTreasure() {
  const value = useContext(TreasureContext);
  if (!value) throw new Error('Treasure workspace required');
  return value;
}
// AppLayout is the sole polling owner. Other observers share its tenant query.
export function useGivingAccess(poll = false) {
  const { churchId } = useAuth();
  const query = useQuery({ queryKey: ['giving', churchId, 'access'],
    queryFn: () => givingApi(churchId!).access(), enabled: !!churchId,
    staleTime: 5000, gcTime: 0, refetchInterval: poll ? 5000 : false,
    refetchOnWindowFocus: 'always', retry: false });
  return {...query, data:query.isError?undefined:query.data};
}
export function useFinancialErrors(error: unknown) {
  const client = useQueryClient();
  const { churchId } = useAuth();
  useEffect(() => {
    if (churchId && axios.isAxiosError(error) && [401, 403].includes(error.response?.status ?? 0)) {
      void clearFinancialState(client, churchId);
    }
  }, [error, churchId, client]);
}
